import { i18n, ORDER_STATUS } from "data/i18n"
import { useTranslation } from "react-i18next";


export const OrderStatus = ({ status, subStatus }) => {
    const { t } = useTranslation();
    if (!status) {
        return <span>Отсутсвует</span>
    }
    let className = ''
    if (status === ORDER_STATUS.NEW || status === ORDER_STATUS.PROCESSING) {
        className = "color-yellow"
    }

    if (status === ORDER_STATUS.CANCELLED || status === ORDER_STATUS.RETURNED) {
        className = "color-red"
    }

    if (status === ORDER_STATUS.PAID) {
        className = "color-green"
    }

    return (
        <span className={className}>
            <span>{t(status)} </span>
            {subStatus && <span>({t(subStatus)})</span>}
        </span>
    )
}
